import {DateType, EnumType, JacksonType} from "@sonner/jackson-service-v2";
import {Atividade} from "../atividade";
import {GrupoAtividade} from "../grupo.atividade";
import {AtividadeHistorico} from "../atividade.historico";
import {Pessoa} from "../pessoa";
import {TipoRegimeISSEnum} from "../../enums/tipo.regime.iss.enum";
import {ContextoIntegracaoGRPEnum} from "../../enums/contexto.integracao.grp.enum";

@JacksonType("ExecucaoIntegracaoGRPTO")
export class ExecucaoIntegracaoGRPTO{

  @EnumType(ContextoIntegracaoGRPEnum)
  tipoIntegracao: ContextoIntegracaoGRPEnum;

  @DateType()
  execucao: Date;

}
